const subtitle = 'Create Sales Territories to receive leads.'

const SalesTerritoryTitle = ({ record, translate, style }) => {
  return <span style={style}>{translate('Create Sales Territories')}</span>
}

export default {
  list: { lazy: () => import('./SalesTerritories'), component: 'SalesTerritoryList' },
  edit: { lazy: () => import('./SalesTerritories'), component: 'SalesTerritoryEdit' },
  create: { lazy: () => import('./SalesTerritories'), component: 'SalesTerritoryCreate' },
  options: {
    create: {
      title: <SalesTerritoryTitle />,
      subtitle: subtitle,
      breadCrumb: 'Create Sales Territories',
    },
    list: {
      title: 'My Sales Territories',
      subtitle: subtitle,
      breadCrumb: 'Sales Territories',
    },
    edit: {
      title: 'Edit Sales Territories',
      subtitle: subtitle,
      breadCrumb: 'Edit Sales Territories',
    },
  },
}
